import { EVENT_STATUS, DISPLAY_MODES, FILTER_SUITES } from '../constants';
import context from '../context';
import isEventVisibleWithinDates from './isEventVisibleWithinDates';

export default function preliminaryFilterEvents(
  events,
  {
    days,
    displayMode = 'week',
    skipPlanning = false,
    skipLeave = false,
    skipAvailability = false,
    whoseEventsIds = [],
    showForeignShifts = false,
    filter = { locationIds: [], positionIds: [] },
    skipUnscheduled = false,
  }
) {
  // take only events that can be viewed within current view
  let result = events.filter((event) => {
    if ((context.isTimeOff(event.type) || event.type === 'availability') && !event.user) {
      return false;
    }

    return isEventVisibleWithinDates(event, displayMode, days);
  });

  result = result.filter(
    (ev) =>
      (filter.suite !== FILTER_SUITES.availability || ev.type === 'availability') &&
      (!skipPlanning || ev.status !== EVENT_STATUS.PLANNING) &&
      (!skipLeave || ev.type !== 'leave') &&
      (!skipAvailability || ev.type !== 'availability') &&
      (!skipUnscheduled || ev.type !== 'shift' || ev.dtstart !== ev.dtend)
  );

  if (!showForeignShifts && filter.locationIds && filter.locationIds.length) {
    result = result.filter((ev) => !ev.location || filter.locationIds.includes(ev.location.id));
  }

  if (!showForeignShifts && filter.positionIds && filter.positionIds.length) {
    result = result.filter((ev) => !ev.position || filter.positionIds.includes(ev.position.id));
  }

  if (whoseEventsIds.length) {
    if (displayMode === DISPLAY_MODES.MONTH) {
      result = result.filter(
        (ev) =>
          (ev.user && whoseEventsIds.includes(ev.user.id)) ||
          ev.applications?.some(({ user }) => whoseEventsIds.includes(user.id)) ||
          whoseEventsIds.includes(ev.offer?.user.id)
      );
    } else {
      result = result.filter(
        (ev) =>
          whoseEventsIds.includes(ev.user?.id) ||
          ev.available ||
          !('user' in ev) ||
          whoseEventsIds.includes(ev.offer?.user.id)
      );
    }
  }

  return result;
}
